import {Card, Form, Row, Statistic} from "antd";
import Link from "antd/es/typography/Link";
import { styled } from "styled-components";

export const StyledDiv = styled.div`
    
height: 100vh;
  width: 100%;
  background: rgb(2,12,74);
  background: linear-gradient(214deg, rgba(2,12,74,1) 26%, rgba(229,47,117,1) 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const StyledCard = styled(Card)`
    box-shadow: -4px 4px 22px -11px rgba(0, 0, 0, 0.75);
    border-radius: 28px;
    border: none;
width: 80%;
  min-height: 15%;
  .ant-card-body{
    
  }
`;
export const StyledCountDown = styled(Statistic.Countdown)<any>`
  .ant-statistic-content{
    font-size: 16px;
    font-weight: bold;

  }
`;

export const CustomLink = styled(Link)`
  text-decoration: none;
`;
export const CustomForm = styled(Form)`
  .ant-form-item-required{
      height: 44px !important;
  }
`;
